import { render, staticRenderFns } from "./CookiePolicyPage.vue?vue&type=template&id=0b6b0fb4&scoped=true&"
import script from "./CookiePolicyPage.vue?vue&type=script&lang=js&"
export * from "./CookiePolicyPage.vue?vue&type=script&lang=js&"
import style0 from "./CookiePolicyPage.vue?vue&type=style&index=0&id=0b6b0fb4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6b0fb4",
  null
  
)

export default component.exports